import { httpClientVendasCoreBff } from 'vendas-core/shared/services'
import { type WebhookTypes } from 'webhooks/shared/entities'

import { useQueryRequest } from '~/ui/hooks/utils'

export function useGetWebhookTypes(paymentProfileId: string | undefined, options?: { enabled?: boolean }) {
  const { data: response, ...rest } = useQueryRequest<WebhookTypes>(
    ['useGetWebhookTypes', paymentProfileId],
    () =>
      httpClientVendasCoreBff<WebhookTypes>({
        url: `/v1/payment-profile/${paymentProfileId}/webhooks/settings/types`,
        method: 'GET'
      }),
    {
      enabled: Boolean(paymentProfileId) && (options?.enabled ?? true)
    }
  )

  return { data: response?.data, ...rest }
}
